import React from "react"
import styles from "./ImageGallery.module.scss"
import Image from "../Image"
import BlockContentWrapper from "../blockContent"
import ImageWrapper from "./imageWrapper"

const DoubleImage = ({ leftImage, rightImage }) => {
  return (
    <div className={styles.doubleImage} data-aos-fade>
      <div>
        {leftImage && (
          <>
            <ImageWrapper caption={leftImage.caption}>
              <Image image={leftImage.image} alt={leftImage.alt} />
            </ImageWrapper>
            <BlockContentWrapper blocks={leftImage.caption} />
          </>
        )}
      </div>
      <div>
        {rightImage && (
          <>
            <ImageWrapper caption={rightImage.caption}>
              <Image image={rightImage.image} alt={rightImage.alt} />
            </ImageWrapper>
            <BlockContentWrapper blocks={rightImage.caption} />
          </>
        )}
      </div>
    </div>
  )
}

export default DoubleImage
